import request from '../axiosInterceptor'
import { DASHBOARD_STALE_AFTER_MS } from '../../utils/constants'

// Workspace list rarely changes, and both ChangeWorkspace (page) and WorkspaceSwitcherDrawer
// call this on every mount/open — cache the in-flight/resolved request for 5 minutes so repeat
// visits within that window don't refetch. Cleared on failure so a rejected request doesn't
// stay cached.
let afterAuthWorkspaceCache: { promise: ReturnType<typeof request>; timestamp: number } | null = null

const api = {
  getWorkspace() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/auth/workspaces`,
      method: 'get',
    })
  },
  getAfterAuthWorkspace() {
    if (afterAuthWorkspaceCache && Date.now() - afterAuthWorkspaceCache.timestamp < DASHBOARD_STALE_AFTER_MS) {
      return afterAuthWorkspaceCache.promise
    }
    const promise = request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/auth/workspaces-access-token`,
      method: 'get',
    }).catch((error) => {
      afterAuthWorkspaceCache = null
      throw error
    })
    afterAuthWorkspaceCache = { promise, timestamp: Date.now() }
    return promise
  },
  // SSO replaces the tokens for a possibly different identity via an in-SPA navigation
  // (no page reload), so the 5-minute cache above must be dropped explicitly — otherwise
  // a call shortly after SSO could still return the previous identity's cached workspaces.
  clearAfterAuthWorkspaceCache() {
    afterAuthWorkspaceCache = null
  },
  postSelectWorkspace(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/auth/select-workspace`,
      method: 'post',
      data: data,
    })
  },
  postChangeWorkspace(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/auth/change-workspace`,
      method: 'post',
      data: data,
    })
  },
}

export default api
